module.exports = __webpack_public_path__ + "img/Avatar-13.5981faa1.gif";